module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('gc-order-list-base', {
    attrs: {
      "orderList": _vm.orderList,
      "show-product-contract-no": _vm.showProductContractNo
    },
    on: {
      "goToOrderDetail": _vm.handleGoToOrderDetail
    },
    scopedSlots: _vm._u([{
      key: "itemButton",
      fn: function(order) {
        return [_vm._t("itemButton", null, null, order), _vm._v(" "), _c('gc-order-list-buttons-base', {
          attrs: {
            "order-detail": order
          },
          on: {
            "goToProgress": _vm.handleGoToOrderDetail,
            "downloadOrderText": _vm.handleDownloadOrderText
          }
        })]
      }
    }], null, true)
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a2f97996","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/emktcommon/orders/order/GcOrderListWithActions.vue
// module id = 1703
// module chunks = 8